import { render, staticRenderFns } from "./k-gold.vue?vue&type=template&id=3adff379&scoped=true&"
import script from "./k-gold.vue?vue&type=script&lang=js&"
export * from "./k-gold.vue?vue&type=script&lang=js&"
import style0 from "./k-gold.vue?vue&type=style&index=0&id=3adff379&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3adff379",
  null
  
)

export default component.exports